'use client';

import { range } from 'lodash';
import { Star } from 'lucide-react';

export function ImportanceStars({ importance }: { importance: number }) {
  const filledCount = Math.min(Math.max(Math.round(importance || 0), 0), 5);

  return (
    <div className="flex items-center gap-0.5">
      {range(5).map((item) => {
        const filled = item < filledCount;

        return (
          <Star
            key={item}
            stroke={filled ? '#FFBE49' : '#3F4349'}
            fill={filled ? '#FFBE49' : '#3F4349'}
            size={14}
          />
        );
      })}
    </div>
  );
}
